









































































import { apiService, AppConstants, Interfaces, Models } from "@/core/Export";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class EmployeeAttendMonthApprove extends Vue {
  monthPairs: Array<Models.EAME_PairDto>;
  notes: string;
  isReject: boolean;
  constructor() {
    super();
    this.monthPairs = new Array<Models.EAME_PairDto>();
    this.notes = null;
    this.isReject = false;
  }

  created() {
    this.onGetEmployeeAttendMonthApprove();
  }
  @Watch("drawerParams")
  @Watch("selectedYear")
  @Watch("selectedMonth")
  onGetEmployeeAttendMonthApprove() {
    this.appEnv.isBusy = true;
    apiService
      .getEmployeeAttendMonthApprove(
        this.currentEmployee.id,
        this.selectedYear,
        this.selectedMonth,
        this.selectedEmpNominationId
      )
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.monthPairs = call.callResult.data as Array<Models.EAME_PairDto>;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onSaveEmployeeAttendMonthApprove(e) {
    e.preventDefault();
    let employeeAttendMonthApproveForm = this.$refs
      .employeeAttendMonthApproveForm as any;
    employeeAttendMonthApproveForm.validate().then((success) => {
      if (success) {
        this.saveEmployeeAttendMonthApprove();
      }
    });
  }

  saveEmployeeAttendMonthApprove() {
    this.appEnv.isBusy = true;
    apiService
      .saveEmployeeAttendMonthApprove(
        this.currentEmployee.id,
        this.isReject,
        this.selectedYear,
        this.selectedMonth,
        this.selectedEmpNominationId
      )
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          store
            .dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData, {
              forceCalc: true,
            })
            .finally(() => {
              this.onCloseEmployeeAttendMonthApproveDrawer();
              this.appEnv.isBusy = false;
            });
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
          this.appEnv.isBusy = false;
        }
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onCloseEmployeeAttendMonthApproveDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});

  }

  set employeeAttendViewData(value) {
    store.commit(
      AppConstants.StoreMutations.UpdateEmployeeAttendViewData,
      value
    );
  }

  get selectedEmpNominationId() {
    return store.getters.selectedEmpNominationId;
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
